import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAccountState } from './types';
import { IAccount } from 'shared-types/DiaryTypes';

const NS = 'accountSlice';

const initialState: IAccountState = {
  account: undefined,
  allAccountsForUser: [],
  isManager: false,
  isAdminUser: false,
  accountLocked: false,
  isIncludedAdminRole: true,
  quantity: 0,
  searchString: '',
  hasAccountCustomerAccess: false,
};

const accountSlice = createSlice({
  name: 'account', // used in action types
  initialState,
  reducers: {
    setAccount: (state: IAccountState, action: PayloadAction<IAccount>) => {
      state.account = action.payload;
    },
    setAllAccountsForUser: (state: IAccountState, action: PayloadAction<IAccount[]>) => {
      state.allAccountsForUser = action.payload;
    },
    setAccountsQuantity: (state: IAccountState, action: PayloadAction<number>) => {
      state.quantity = action.payload;
    },
    setAccountSearchString: (state: IAccountState, action: PayloadAction<string>) => {
      state.searchString = action.payload;
    },
    setIsManager: (state: IAccountState, action: PayloadAction<boolean>) => {
      state.isManager = action.payload;
    },
    setAccountLocked: (state: IAccountState, action: PayloadAction<boolean>) => {
      state.accountLocked = action.payload;
    },
    setIsIncludedAdminRole: (state: IAccountState, action: PayloadAction<boolean>) => {
      state.isIncludedAdminRole = action.payload;
    },
    setIsAdminUser: (state: IAccountState, action: PayloadAction<boolean>) => {
      state.isAdminUser = action.payload;
    },
    setHasAccountCustomerAccess: (state: IAccountState, action: PayloadAction<boolean>) => {
      state.hasAccountCustomerAccess = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = accountSlice;
// Extract and export each action creator by name
export { actions as accountActions };
// Export the reducer, either as a default or named export
export default reducer;
